import { render } from "./Sound.vue?vue&type=template&id=79fa1aec&scoped=true&ts=true&lang=pug"
import script from "./Sound.vue?vue&type=script&lang=ts"
export * from "./Sound.vue?vue&type=script&lang=ts"

import "./Sound.vue?vue&type=style&index=0&id=79fa1aec&scoped=true&lang=css"

import exportComponent from "/builds/checkmeru/renova-telemedicine/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79fa1aec"]])

export default __exports__